import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_CONVERSATION_HISTORY = 'GET_CONVERSATION_HISTORY';
export const GET_CONVERSATION_HISTORY_SUCCESS =
	'GET_CONVERSATION_HISTORY_SUCCESS';
export const GET_CONVERSATION_HISTORY_FAIL = 'GET_CONVERSATION_HISTORY_FAIL';
export const GET_CONVERSATION_HISTORY_RESET = 'GET_CONVERSATION_HISTORY_RESET';

export const getConversationHistory = (params) => {
	return {
		type: GET_CONVERSATION_HISTORY,
		params,
	};
};

export const getConversationHistorySuccess = (response) => {
	return {
		type: GET_CONVERSATION_HISTORY_SUCCESS,
		response,
	};
};

export const getConversationHistoryFail = (response) => {
	return {
		type: GET_CONVERSATION_HISTORY_FAIL,
		response,
	};
};

export const getConversationHistoryReset = () => {
	return {
		type: GET_CONVERSATION_HISTORY_RESET,
	};
};

export const getConversationHistoryApi = (data) => {
	return (dispatch) => {
		dispatch(getConversationHistory());
		axios
			.get(`${config.api.base_url}/voice-assistance/history`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const historyData = response.data;
				dispatch(getConversationHistorySuccess(historyData));
			})
			.catch((error) => {
				const errorMsg = error.response
					? error.response.data
					: error.message;
				dispatch(getConversationHistoryFail(errorMsg));
			});
	};
};
